import { DesignFile } from "../../Interfaces/FundraiserRole";

const CUSTOMIZATION_OPTIONS = [
  { text: "No Text on Back - $0", upcharge: 0 },
  { text: "Name - $6", upcharge: 6 },
  { text: "Name and Number - $10", upcharge: 10 },
  { text: "Cheer Bow and Vertical Name - $6", upcharge: 6 },
];

const AVAILABLE_FONTS = [
  "Dancing Script",
  "Storybook",
  "Witches and Wizards",
  "Varsity Team",
  "Advera",
];

const DEFAULT_PARTICIPANT = {
  id: 0,
  first_name: "Participant",
  last_name: "",
  participant_code: "",
  primary_division: {
    id: 0,
    name: "",
    description: "",
    fundraiser: 0,
    parent_division: null,
    level: 0,
    path: "",
  },
  secondary_division: {
    id: 0,
    name: "",
    description: "",
    fundraiser: 0,
    parent_division: null,
    level: 0,
    path: "",
  },
  supporter_count: 0,
  current_profit: 0,
  current_goal: 0,
  profile_image_url: "",
};

export { CUSTOMIZATION_OPTIONS, AVAILABLE_FONTS, DEFAULT_PARTICIPANT };
